<div class="sidebar-map">
  <app-sidebar-path
    *ngIf="sidebarType == systemModuleEnum.Path"
    class="w-100 h-100"
    (changeIdEmitter)="handleIdSelected($event)"
    [sidebarIdSelected]="sidebarIdSelected"
    [kilometerSelected]="kilometerSelected"
    [googleMap]="googleMap"
    [pathLayer]="pathLayer"
    [retroMeasurementList]="retroMeasurementList"
    [retroMeasurementTrafficList]="retroMeasurementTrafficList"
  >
  </app-sidebar-path>

  <app-sidebar-task
    *ngIf="sidebarType == systemModuleEnum.Task && selectedTask"
    class="w-100 h-100"
    (changeIdEmitter)="handleIdSelected($event)"
    [selectedTask]="selectedTask"
    [sidebarIdSelected]="sidebarIdSelected"
  >
  </app-sidebar-task>

  <app-sidebar-team
    *ngIf="sidebarType == systemModuleEnum.Team"
    class="w-100 h-100"
    (changeIdEmitter)="handleIdSelected($event)"
    [sidebarIdSelected]="sidebarIdSelected"
    [currentTeamVehicle]="currentTeamVehicle"
  >
  </app-sidebar-team>

  <app-side-dashboard
    *ngIf="sidebarType == systemModuleEnum.Catalog"
    class="w-100 h-100"
    [signList]="signList"
    [taskList]="taskList"
    [warrantyStatus]="warrantyStatus"
    [retroStatus]="retroStatus"
    [signalingTypes]="signalingsTypes"
    [checkOptionsFilter]="checkOptionsFilter"
    [catalogFilter]="catalogFilter"
    [signTypeFilterFn]="signTypeFilterFn"
    [signWarrantyFilterFn]="signWarrantyFilterFn"
    [signRetroFilterFn]="signRetroFilterFn"
    >
  </app-side-dashboard>
</div>
